import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import messages_en from "./locales/en.json";
import messages_fr from "./locales/fr.json";

const resources = {
  en: {
    translation: messages_en,
  },
  fr: {
    translation: messages_fr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
